import { request } from './api.js';

// 获取退款列表
export const refundList = (data) => request('/_hotel/refund/list', 'get', data);

//消费退款 /_hotel/refund/consumeRefund
export const consumeRefund = (data) => request('/_hotel/refund/consumeRefund', 'post', data, {}, true);

//充值退款 /_hotel/refund/chargeRefund
export const chargeRefund = (data) => request('/_hotel/refund/chargeRefund', 'post', data, {}, true);

// 消费退款详情 /_hotel/refund/consumeDetail/{id}
export const consumeRefundDetail = (data) => request(`/_hotel/refund/consumeDetail/${data.id}`, 'get', {}, {}, true);

//充值退款详情 /_hotel/refund/chargeDetail/{id}
export const chargeRefundDetail = (data) => request(`/_hotel/refund/chargeDetail/${data.id}`, 'get', {}, {}, true);

// 退款购物项的预览 /_hotel/refund/consumeRefundPreview
export const consumeRefundPreview = (data) => request('/_hotel/refund/consumeRefundPreview', 'post', data, {}, true);

// 退款重试 /_hotel/refund/retryPostProcess
export const retryPostProcess = (data) => request('/_hotel/refund/retryPostProcess', 'post', data, {}, true);

//取消支付 /_hotel/room_expend/payment_online/cancel
export const cancelPaymentOnline = (data) => request('/_hotel/room_expend/payment_online/cancel', 'post', data, {}, true);

// 部分结账 /_hotel/room_expend/windup_part
export const partialSettlementPay = (data) => request('/_hotel/room_expend/windup_part', 'post', data, {}, true);

// 获取账单活动列表 /_hotel/room/order/get-bill-activity/{id}
export const getBillSaleActivity = (data) => request(`/_hotel/room/order/get-bill-activity/${data.id}`, 'get', data);

// 取消账单活动 /_hotel/room/order/cancel-bill-activity/{id}
export const cancelBillSaleActivity = (data) => request(`/_hotel/room/order/cancel-bill-activity/${data.id}`, 'put', data, {}, true);

//撤销所有活动 /_hotel/room/order/revoke-bill-activity/{id}
export const revokeBillSaleActivity = (data) => request(`/_hotel/room/order/revoke-bill-activity/${data.id}`, 'put', data, {}, true);
